import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { TooltipComponent } from 'components/tooltip/tooltip.component';
import { FileUploadComponent } from 'components/file-upload/file-upload.component';
import { SubmissionNoteModalComponent } from 'components/modal/submission-note-modal/submission-note-modal.component';
import { BaseFormComponent } from 'components/form/base-form';
import { FILE_OBJECT_TYPE_SUMBISSION_NOTE } from 'types/file.interface';
import {
  ReadingRoomSubmissionNoteListByReadingRoomSubmissionIdItemDto,
  ReadingRoomSubmissionNoteCardDto,
  BackofficeReadingRoomSubmissionCard
} from 'types/service.interface';
import { formatDatetime } from 'util/date.utility';
import { USER_SECURITY_INFO_KEY } from 'services/authorization.service';
import { ConfirmModalComponent } from 'components/modal/confirm-modal/confirm-modal.component';

@Component({
  selector: 'app-reading-room-submission-notes',
  standalone: true,
  imports: [TooltipComponent, TranslateModule, FileUploadComponent, SubmissionNoteModalComponent, ConfirmModalComponent],
  templateUrl: './reading-room-submission-notes.component.html',
  styleUrl: './reading-room-submission-notes.component.scss'
})
export class ReadingRoomSubmissionNotesComponent extends BaseFormComponent implements OnInit, OnChanges {
  override fillForm(): void {
    throw new Error('Method not implemented.');
  }
  @Input() application!: BackofficeReadingRoomSubmissionCard;
  @Input() userId!: string;
  @Input()
  notes?: ReadingRoomSubmissionNoteListByReadingRoomSubmissionIdItemDto[];
  @Input() isSubmittingNoteFiles: boolean = false;

  @Output() submissionNotesChanged = new EventEmitter<
    ReadingRoomSubmissionNoteListByReadingRoomSubmissionIdItemDto | ReadingRoomSubmissionNoteCardDto | void
  >();

  public readonly formatDatetime = formatDatetime;
  public readonly submissionNoteFileType = FILE_OBJECT_TYPE_SUMBISSION_NOTE;

  notesCount?: number;
  areNotesLoading = true;
  isOpenConfirmDeleteNote = false;
  isAddNoteModalOpen = false;
  isEditNoteModalOpen = false;
  noteToDelete: string | null = null;
  editingNote: ReadingRoomSubmissionNoteCardDto | ReadingRoomSubmissionNoteListByReadingRoomSubmissionIdItemDto | null = null;

  override ngOnInit(): void {
    const userSecurityInfo = localStorage.getItem(USER_SECURITY_INFO_KEY);
    if (userSecurityInfo) {
      try {
        const parsedInfo = JSON.parse(userSecurityInfo);
        this.userId = parsedInfo.userId;
      } catch (error) {
        console.error('Error parsing user info:', error);
      }
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['application']) {
      this.application = changes['application'].currentValue;
    }
  }

  openAddNoteModal(): void {
    this.isAddNoteModalOpen = true;
  }

  openEditNoteModal(note: ReadingRoomSubmissionNoteCardDto): void {
    this.editingNote = note;
    this.isEditNoteModalOpen = true;
  }

  onModalClose(): void {
    this.isAddNoteModalOpen = false;
    this.isEditNoteModalOpen = false;
  }

  onNoteSaved(note: ReadingRoomSubmissionNoteCardDto): void {
    this.submissionNotesChanged.emit(note);
  }

  openConfirmModal(noteId: string): void {
    this.noteToDelete = noteId;
    this.isOpenConfirmDeleteNote = true;
  }

  handleRemove(noteId: string) {
    this.apiService.deleteReadingRoomSubmissionNote(noteId).subscribe(
      () => {
        this.toastService.showSuccess('deleteSubmissionNoteSuccess', '', {
          shouldTranslate: true
        });
        this.isOpenConfirmDeleteNote = false;
        this.submissionNotesChanged.emit();
        this.onSubmitSuccess();
      },
      (error: any) => {
        this.toastService.showRequestError();
        console.error('Error Deleting reading room submission note value:', error);
      }
    );
    this.noteToDelete = null;
  }
}
